<template>
	<div>
		<!-- 登录信息 -->
		<global-tips></global-tips>
		<el-card>
			<!-- 搜索框 -->
			 <el-form v-show="showSearch" ref="queryForm" :model="queryForm" inline size="small">
				<el-form-item label="名称" label-width="50px" prop="keyword">
				  <el-input v-model="queryForm.keyword" placeholder="请输入名称/编码" type="text" clearable style="width: 230px" />
				</el-form-item>
				<el-form-item label="产品类型" label-width="70px" prop="type_id">
				   <el-select v-model="queryForm.cat_id" placeholder="请选择产品类型" class="w-100">
					<el-option label="无" value=""></el-option>
					<el-option v-for="(item,index) in category" :key="index"
						:label="item | tree" 
						:value="item.id">
					</el-option>
				   </el-select>
				</el-form-item>
				<el-form-item label="采购时间" label-width="70px" prop="procure_time">
				  <el-date-picker
					v-model="queryForm.procure_time"
					type="daterange"
					value-format="yyyy-MM-dd"
					style="width: 260px;"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期">
				  </el-date-picker>
				</el-form-item>
				<el-form-item>
				  <el-button type="primary" icon="el-icon-search" size="mini" @click="query">查询</el-button>
				  <el-button icon="el-icon-refresh" size="mini" @click="resetQuery('queryForm')">重置</el-button>
				</el-form-item>
			</el-form>
			<!--自定义刷新组件-->
			<el-row :gutter="10" class="mb-1">
				<el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd">新增</el-button>
				<right-toolbar :show-search.sync="showSearch" @queryTable="query" />
			</el-row>
			<!--表格-->
			 <el-table
				v-loading="loading"
				size="small"
				:data="list"
				element-loading-text="Loading"
				highlight-current-row
				style="width: 100%"
			 >
				<el-table-column label="序号" width="80" align="center">
				  <template slot-scope="scope">
					{{ (queryForm.page - 1) * queryForm.limit + scope.$index + 1 }}
				  </template>
				</el-table-column>
				<el-table-column label="名称" min-width="110" align="center">
				  <template slot-scope="scope">
					<span>{{ scope.row.name }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="编码" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.bn }}
				  </template>
				</el-table-column>
				<el-table-column label="类型" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.cate_name }}
				  </template>
				</el-table-column>
				<el-table-column label="单价" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.price }}
				  </template>
				</el-table-column>
				<el-table-column label="数量" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.nums }}
				  </template>
				</el-table-column>
				<el-table-column label="金额" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.money }}
				  </template>
				</el-table-column>
				<el-table-column label="状态" min-width="70" align="center">
				  <template slot-scope="scope">
					<el-tag v-if="scope.row.status === 1" size="mini" type="success">正常</el-tag>
					<el-tag v-if="scope.row.status === 2" size="mini" type="danger">停用</el-tag>
				  </template>
				</el-table-column>
				<el-table-column align="center" prop="utime" label="时间" min-width="170">
				  <template slot-scope="scope">
					<i class="el-icon-time" />
					<span>{{ scope.row.ctime }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="操作" min-width="170" align="center" fixed="right">
				  <template slot-scope="scope">
					<el-tooltip class="item" effect="dark" content="记录" placement="top">
					  <el-button type="success" icon="el-icon-document" size="mini" circle @click="handleLog(scope.row)"></el-button>		
					</el-tooltip>
					<el-tooltip class="item" effect="dark" content="出入库" placement="top">
					  <el-button type="warning" icon="el-icon-document-remove" size="mini" circle @click="handleCk(scope.row)"></el-button>		
					</el-tooltip>
					<el-tooltip class="item" effect="dark" content="出入库记录" placement="top">
					  <el-button type="warning" icon="el-icon-date" size="mini" circle @click="handleCkLog(scope.row)"></el-button>		
					</el-tooltip>
					<el-tooltip class="item" effect="dark" content="编辑" placement="top">
					  <el-button type="warning" icon="el-icon-edit" size="mini" circle @click="handleEdit(scope.row)"></el-button>		
		            </el-tooltip>
					<el-tooltip class="item" effect="dark" content="删除" placement="top">
					  <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="handleDelete(scope.row.id)"></el-button>		
					</el-tooltip>
				  </template>
				</el-table-column>
			 </el-table>
			 <pagination
				:total="total"
				auto-scroll
				:page.sync="queryForm.page"
				:limit.sync="queryForm.limit"
				@pagination="query"
			 />
		</el-card>
		<!-- 修改余额 -->
		<el-dialog :visible.sync="openDialog" width="600px" :close-on-click-modal="false" append-to-body :title="title">
			 <el-form ref="ckform" :model="ckform" :rules="ckRules" label-width="80px" size="small">
			   <el-form-item label="产品名称" prop="name">
				   <template>
					 {{ckform.name || ''}}
				   </template>
			   </el-form-item>
			   <el-form-item label="产品编码" prop="bn">
				   <template>
					 {{ckform.bn || ''}}
				   </template>
			   </el-form-item>
			   <el-form-item label="当前库存" prop="nums">
				   <template>
					 {{ckform.nums || 0}}
				   </template>
			   </el-form-item>
			   <el-form-item label="库存变动" prop="value">
				   <el-input v-model="ckform.value" placeholder="请输入库存" type="number" clearable />
				   <small class="text-danger">正数为加，负数为减</small>
			   </el-form-item>
			   <el-form-item label="变动说明" prop="desc">
				   <el-input v-model="ckform.desc" placeholder="请输入变动说明" type="text" clearable />
			   </el-form-item>
			 </el-form>
			 <div slot="footer" class="dialog-footer">
			   <el-button size="mini" @click="openDialog = false">取 消</el-button>
			   <el-button type="primary" size="mini" @click="handleCkSubmit">确 定</el-button>
			 </div>
		</el-dialog>
		<!-- 日志列表 -->
		 <el-dialog
			 :visible.sync="openCklog"
			 width="950px"
			 :close-on-click-modal="false"
			 append-to-body
			 title="日志"
		   >
			 <el-table
			   v-loading="listLoading"
			   size="small"
			   :data="log_list"
			   element-loading-text="Loading"
			   highlight-current-row
			   style="width: 100%"
			 >
			   <el-table-column label="ID" width="80" align="center">
				 <template slot-scope="scope">
				   {{ scope.row.id }}
				 </template>
			   </el-table-column>
			   <el-table-column label="编码" align="center">
				 <template slot-scope="scope">
				   <span>{{ scope.row.bn || 0}}</span>
				 </template>
			   </el-table-column>
			   <el-table-column label="描述" align="center">
				 <template slot-scope="scope">
				   <span>{{ scope.row.msg }}</span>
				 </template>
			   </el-table-column>
			   <el-table-column label="变更数量" align="center">
				 <template slot-scope="scope">
				   <span>{{ scope.row.nums || 0}}</span>
				 </template>
			   </el-table-column>
			   <el-table-column label="编辑" align="center">
				 <template slot-scope="scope">
				   <span>{{ scope.row.username || ''}}</span>
				 </template>
			   </el-table-column>
			   <el-table-column align="center" label="变更时间">
				 <template slot-scope="scope">
				   <span>{{ scope.row.ctime }}</span>
				 </template>
			   </el-table-column>
			 </el-table>
			 <pagination
			   :total="page.total"
			   auto-scroll
			   :page.sync="page.page"
			   :limit.sync="page.limit"
			   @pagination="getKclog"
			 />
			 <div slot="footer" class="dialog-footer"></div>
		</el-dialog>
	</div>
</template>

<script>
	import GlobalTips from "@/components/GlobalTips";
	import common from "@/common/mixins/common.js"
	export default {
		inject:['app'],
		mixins:[common],
		components: {
			GlobalTips,
		},
		data() {
			return {
				preUrl: 'kc_kcgl',
				queryForm: {
					page: 1,
					limit: 10,
					keyword: '',
					cat_id:'',
					procure_time:[],
				},
				category:[],
				openDialog:false,
				ckform:{
					id:'',
					nums:0,
					value:'',
					desc:'',
				},
				ckRules:{
					value: [
					  { required: true, message: '请输入值', trigger: 'blur' }
					],
				},
				openCklog:false,
				listLoading: false,
				page: {
					page: 1,
					limit: 10,
					total:0,
					keyword: '',
				},
				log_list:[],
				
			}
		},
		filters: {
			tree(item) {
				if (item.level == 0) {
					return item.name
				}
				let str = ''
				for (let i = 0; i < item.level; i++) {
					str += i == 0 ? '|--' : '--'
				}
				return str + ' ' +item.name;
			}
		},
		mounted() {
			this.getCategory()
		},
		methods:{
			handleCkLog(item){
				this.getKclog()
				this.$nextTick(()=>{
				  this.title = '日志列表'
				  this.openCklog = true
				})
			},
			getKclog(){
				this.axios.get('/manage/ck_log/list',{
				  params: {
					page:this.page.page,
					limit:this.page.limit,
					keyword:this.page.keyword,
				  }
				}).then(res=>{
				  this.page.total = res.total
				  this.log_list = res.data
				})
			},
			handleCkSubmit(){
				this.$refs.ckform.validate(valid => {
				   if (valid) {
					    this.axios.put('/manage/ck_log/edit/'+this.ckform.id,this.ckform).then(res=>{
						  if(res.status){
							this.$message.success('编辑成功')
							this.openDialog = false
							this.title = ''
							this.getList()
						  }else{
							this.$message.error(res.msg)
						  }
						})
				   }
				})
			},
			handleCk(item){
				this.ckform = {
					id:item.id,
					name:item.name,
					bn:item.bn,
					nums:item.nums,
					value:'',
					desc:'',
				}
				this.title = '出库'
				this.openDialog = true
			},
			handleLog(item){
				this.$router.push({
				  path:"/kcgl_log",
				  query: {
					  id:item.id
				  }
				})
			},
			handleAdd(){
				this.$router.push({
				  path:"/kcgl_edit",
				  query: {}
				})
			},
			handleEdit(row) {
				this.$router.push({
				  path:"/kcgl_edit",
				  query: {
					  info:JSON.parse(JSON.stringify(row))
				  }
				})
			},
			handleView(row){
				this.$router.push({
				  path:"/kcgl_detail",
				  query: {
					  id:row.id
				  }
				})
			},
			viewImage(url) {
			  this.app.previeImage(url)
			},
			getCategory(){
				this.axios.get('/manage/category/tree').then(res=>{
					if(res.status){
						this.category = res.data
					}
				})
			},
		}
	}
</script>

<style>
</style>